import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import Link from "@mui/material/Link";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import library from "../../assets/images/computer_skills.jpg";

const Digital = () => {
  return (
    <Box>
      <Helmet>
        <title>
          Digital Foundations: Building Your Computer Confidence | Oluseun
          Onigbinde Resource Centre
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        padding={"5px 0px"}
        sx={{
          backgroundColor: "#F6F5F5",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Box
            sx={{
              position: "relative",
              "&::after": {
                position: "absolute",
                content: '""',
                width: "30%",
                zIndex: 1,
                top: 0,
                right: 0,
                height: "80%",
                backgroundSize: "18px 18px",
                backgroundImage: `radial-gradient(${"#071783"} 20%, transparent 30%)`,
                opacity: 0.1,
              },
            }}
          >
            <Typography
              gutterBottom
              fontWeight={300}
              variant="h3"
              paddingTop={{ xs: "35%", sm: "5%" }}
              color="#071783"
            >
              Digital Foundations: Building Your Computer Confidence
            </Typography>
            <Box
              width={{ xs: "80%", sm: "15%" }}
              marginLeft={{ xs: "0%", sm: "0%" }}
            >
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<DoubleArrowIcon fontSize="small" />}
              >
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="#000"
                  href="/"
                  gap={0.5}
                >
                  <HomeIcon
                    sx={{ color: "#071783", width: 18, height: 18 }}
                    fontSize="inherit"
                  />
                  Home
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="#000"
                  href="/our-events"
                  gap={0.5}
                >
                  <MenuBookIcon
                    sx={{ color: "#071783", width: 18, height: 18 }}
                    fontSize="inherit"
                  />
                  Events
                </Link>
              </Breadcrumbs>
            </Box>
          </Box>
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Grid
            container
            display={"flex"}
            alignItems={"flex-start"}
            margin={{ xs: "0%", sm: "2% 0%" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              marginBottom={{ xs: "0%", sm: "0%" }}
              padding={{ xs: "15% 0% 15% 0%", sm: "0% 6% 3% 0%" }}
            >
              <Box
                component="img"
                height={{ xs: "45vh", sm: "600px" }}
                width={{ xs: "100%", sm: "100%" }}
                display={{ xs: "block", sm: "none" }}
                marginTop={{ xs: "10%", sm: "0%" }}
                src={library}
                alt={"image"}
                sx={{
                  objectFit: "cover",
                }}
              />

              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#071783"}
                marginTop={{ xs: "5%", sm: "0%" }}
                paddingBottom={"1%"}
              >
                March 8, 2025
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "5% 0% 2% 0%", sm: "4% 0% 0% 0%" }}
                lineHeight={1.5}
              >
                Join us for a comprehensive workshop designed to equip you with
                the basic computer skills you need to succeed in today's digital
                world. In this interactive and engaging session, you'll learn
                the fundamentals of computer usage, including:
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "2% 0%", sm: "4% 0% 0% 0%" }}
              >
                &#8226; Basic computer terminology and concepts
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "2% 0%", sm: "2% 0% 0% 0%" }}
              >
                &#8226; Navigating operating systems and software applications
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "2% 0%", sm: "2% 0% 0% 0%" }}
              >
                &#8226; Creating and managing digital files and documents
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "2% 0%", sm: "2% 0% 0% 0%" }}
              >
                &#8226; Online safety and security best practices
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "4% 0%", sm: "4% 0% 0% 0%" }}
                lineHeight={1.5}
              >
                Our expert instructor will guide you through hands-on exercises
                and real-world examples, helping you build confidence and
                competence in using computers. Whether you're a complete
                beginner or looking to refresh your skills, this workshop is
                perfect for anyone seeking to improve their digital literacy and
                stay connected in the modern world.
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={700}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "2% 0%", sm: "4% 0% 0% 0%" }}
                lineHeight={1.5}
              >
                Don't miss this opportunity to unlock your digital potential!
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              padding={{ xs: "15% 0% 25% 0%", sm: "0% 0% 3% 0%" }}
              margin={{ xs: "25% 0% 10% 0%", sm: "0%" }}
              display={{ xs: "none", sm: "block" }}
            >
              <Box
                component="img"
                height={{ xs: "45vh", sm: "600px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={library}
                alt={"image"}
                sx={{
                  objectFit: "cover",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Digital;
